import {
    LuLayoutDashboard,
    LuUsers,
    LuClipboardCheck,
    LuSquarePlus,
    LuLogOut,
} from 'react-icons/lu';
import { FaRegFolder } from "react-icons/fa";
import { FaFolderTree } from "react-icons/fa6";

export const SIDE_MENU_DATA = [
    {
        id:"01",
        label: "Tableau de bord",
        icon: LuLayoutDashboard,
        path: '/admin/dashboard',
    },{
      
        id:"02",
        label: "gerer projets",
        icon:FaFolderTree,
        path: '/admin/project-list'  
    },{
      
        id:"03",
        label: "projets",
        icon: FaRegFolder ,
        path: '/admin/project'  
    },
    {
        id:"04",
        label: "gerer les taches",
        icon: LuClipboardCheck,
        path: '/admin/manage-tasks',
    },
    {
        id:"05",
        label: "Taches",
        icon: LuSquarePlus,
        path: '/admin/tasks',
    },
    {
        id:"06",
        label: "membre d'équipe",
        icon: LuUsers,
        path: '/admin/manage-users',
       
    },
    {
        id:"07",
        label: "se deconnecter",
        icon: LuLogOut,
        path: 'logout',
       
    },
]

export const SIDE_MENU_USER_DATA = [
    {
        id:"01",
        label: "Tableau de bord",
        icon: LuLayoutDashboard,
        path: '/user/dashboard',
    },
    {
        id:"02",
        label: "Mes Taches",
        icon: LuClipboardCheck,
        path: '/user/tasks',
    },
    {
        id:"03",
        label: "se deconnecter",
        icon: LuLogOut,
        path: 'logout',
    }
]
export const PRIORITY_DATA = [
    {  label: 'faible', value: 'faible' },
    {  label: 'moyen', value: 'moyen' },
    {  label: 'élevé', value: 'élevé' },
]

export const  STATUS_DATA = [
    {  label: 'enattente', value: 'enattente' },
    {  label: 'encours', value: 'encours' },
    {  label: 'terminé', value: 'terminé' },
]